var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDrop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.5,
    height: 6,
    viewBox: "0 0 11.5 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow-Down_2",
    "data-name": "Arrow-Down 2",
    d: "M15.53,7.444a.607.607,0,0,1,0,.934L10,13.25,4.47,8.378a.607.607,0,0,1,0-.934.823.823,0,0,1,1.061,0L10,11.381l4.47-3.938A.823.823,0,0,1,15.53,7.444Z",
    transform: "translate(-4.25 -7.25)",
    fill: "#888",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDrop);
export default __webpack_public_path__ + "static/media/arrow-drop.0fdca7d20d415fa96ccc1c23cb61f643.svg";
export { ForwardRef as ReactComponent };